import { HubProvider } from '@hub/design-system-base'
import React, { useContext } from 'react'
import { LinkContext } from '../context'

const EvolvedContext = React.createContext(false)
EvolvedContext.displayName = 'EvolvedContext'

export const EvolvedContextProvider: React.FC<{ isEvolved: boolean }> = ({
  isEvolved,
  children,
}) => {
  const Link = useContext(LinkContext)
  const tree = isEvolved ? (
    <HubProvider Link={Link}>{children}</HubProvider>
  ) : (
    children
  )
  return (
    <EvolvedContext.Provider value={isEvolved}>{tree}</EvolvedContext.Provider>
  )
}

export const EvolvedContextConsumer = EvolvedContext.Consumer

export const useEvolvedContext = (): boolean => useContext(EvolvedContext)
